module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};\nvar additionalClasses = [];\nif(model.isProject) {\nadditionalClasses.push('isProject');\n}\n%>\n<div class=\"<%= additionalClasses.join(' '); %>\">\n<div class=\"image\" style=\"background-image:url(<%- image.url %>)\"></div>\n<div class=\"content\">\n<div class=\"info\">\n<div class=\"title\"><%- model.title %></div>\n<div class=\"address\">\n<%-\nString(model.address || '')\n.replace(/^[\\s,]*<p>[\\s,]*/g, '<p>')\n.replace(/[\\s,]*<\\/p>[\\s,]*$/g, '</p>')\n%>\n</div>\n<div class=\"details\">\n<%\nif(model.isProject){\n%>\n<p><%- model.shortDescription %></p>\n<table>\n<tr>\n<td>Bezug:</td>\n<td><%- model.moveInto %></td>\n</tr>\n</table>\n<%\n} else {\nvar price = 'auf Anfrage'\nif(model.price * 1) {\nprice = '&euro;&nbsp;' + parseFloat(String(model.price || '0').toString().replace(/[^\\d\\.]/g, \"\")).toFixed(2).toString().replace('\\.', ',').replace(/(\\d)(?=(\\d\\d\\d)+(?!\\d))/g, '$1.')\n}\n%>\n<table>\n<tr>\n<td>Nutzfläche:</td>\n<td><%- parseFloat(String(model.space || '0').toString().replace(/[^\\d\\.]/g, \"\")).toFixed(2).toString().replace('\\.', ',').replace(/(\\d)(?=(\\d\\d\\d)+(?!\\d))/g, '$1.') %> m<sup>2</sup></td>\n</tr>\n<tr>\n<td>Bezug:</td>\n<td><%- model.moveInto %></td>\n</tr>\n<tr>\n<td>Miete:</td>\n<td><%- price %></td>\n</tr>\n</table>\n<%\n}\n%>\n</div>\n</div>\n</div>\n</div>"
  , __filename = "components/templates/commercialProperties/object.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};
var additionalClasses = [];
if(model.isProject) {
additionalClasses.push('isProject');
}

    ; __line = 7
    ; __append("\n<div class=\"")
    ; __line = 8
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\">\n<div class=\"image\" style=\"background-image:url(")
    ; __line = 9
    ; __append( image.url )
    ; __append(")\"></div>\n<div class=\"content\">\n<div class=\"info\">\n<div class=\"title\">")
    ; __line = 12
    ; __append( model.title )
    ; __append("</div>\n<div class=\"address\">\n")
    ; __line = 14
    ; __append(
String(model.address || '')
.replace(/^[\s,]*<p>[\s,]*/g, '<p>')
.replace(/[\s,]*<\/p>[\s,]*$/g, '</p>')
)
    ; __line = 18
    ; __append("\n</div>\n<div class=\"details\">\n")
    ; __line = 21
    ; 
if(model.isProject){

    ; __line = 23
    ; __append("\n<p>")
    ; __line = 24
    ; __append( model.shortDescription )
    ; __append("</p>\n<table>\n<tr>\n<td>Bezug:</td>\n<td>")
    ; __line = 28
    ; __append( model.moveInto )
    ; __append("</td>\n</tr>\n</table>\n")
    ; __line = 31
    ; 
} else {
var price = 'auf Anfrage'
if(model.price * 1) {
price = '&euro;&nbsp;' + parseFloat(String(model.price || '0').toString().replace(/[^\d\.]/g, "")).toFixed(2).toString().replace('\.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
}

    ; __line = 37
    ; __append("\n<table>\n<tr>\n<td>Nutzfläche:</td>\n<td>")
    ; __line = 41
    ; __append( parseFloat(String(model.space || '0').toString().replace(/[^\d\.]/g, "")).toFixed(2).toString().replace('\.', ',').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') )
    ; __append(" m<sup>2</sup></td>\n</tr>\n<tr>\n<td>Bezug:</td>\n<td>")
    ; __line = 45
    ; __append( model.moveInto )
    ; __append("</td>\n</tr>\n<tr>\n<td>Miete:</td>\n<td>")
    ; __line = 49
    ; __append( price )
    ; __append("</td>\n</tr>\n</table>\n")
    ; __line = 52
    ; 
}

    ; __line = 54
    ; __append("\n</div>\n</div>\n</div>\n</div>")
    ; __line = 58
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/commercialProperties/object.ejs

}